
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import Button from 'common/components/elements/buttons/primary';

const PodConnectionBanner = ({ openOrClosePodConnectionModal }) => {
   return (
      <>
         {
            createPortal(
               <div className='fixed bottom-0 right-0 z-[60] m-3'>
                  <div className='flex h-full w-full relative bg-orange-200 dark:bg-orange-dark-200 px-4 py-3 border-2 border-collapse rounded-lg border-divider dark:border-divider-dark gap-2'>
                     <span className='font-medium text-major dark:text-major-dark underline'>You are connected to the pod: "{ localStorage.getItem('X_CRETRIX_POD') }"</span>
                     <PodConnectionBannerButton
                        onClick={ _ => {
                           localStorage.removeItem('X_CRETRIX_POD');
                           openOrClosePodConnectionModal(false);
                           window.location.reload();
                        } }
                     />
                     <PodConnectionBannerButton
                        className='absolute top-[-10px] right-[-10px]'
                        onClick={ _ => openOrClosePodConnectionModal(false) }
                        color='secondary'
                        dataToolTipContent='Close popup'
                        iconName='cancel'
                     />
                  </div>
               </div>
               ,
               document.getElementById('root')
            )
         }
      </>

   )
}

const PodConnectionBannerButton = ({
   onClick,
   className = '',
   color = 'red',
   dataToolTipContent = 'Leave pod mode',
   iconName = 'exit',
}) => {
   return (
      <div className={ `flex w-6 h-6 ${ className }` }>
         <Button
            iconName={ iconName }
            fontIconColor={ color }
            darkIconColor={ `${ color }-dark` }
            backgroundColor='transparent'
            onClick={ onClick }
            padding='none'
            classNames='h-6 w-6'
            fontIconSize='extraLarge'
            dataToolTipContent={ dataToolTipContent }
         />
      </div>
   )
}

PodConnectionBanner.propTypes = {
   openOrClosePodConnectionModal: PropTypes.func,
};
PodConnectionBannerButton.propTypes = {
   onClick: PropTypes.func,
   className: PropTypes.string,
   color: PropTypes.string,
   dataToolTipContent: PropTypes.string,
   iconName: PropTypes.string,
};

export default PodConnectionBanner;
